import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

// Slow, elegant scroll-reveal wrapper
export const Reveal = ({ children, delay = 0, y = 24, className = "", ...props }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 1.2, ease: EASE, delay }}
    className={className}
    {...props}
  >
    {children}
  </motion.div>
);

export const EASE_EDITORIAL = EASE;
